import { defaultCalendarBlockTitles } from "@caredna-marlin/utils/calendarBlockHelper";
import { Availability, freqToString } from "@caredna-marlin/utils/client/availability";
import { Badge, MenuItem, Select, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ALL_WEEKDAYS, Frequency, RRule } from "rrule";

type Props = {
  disabled?: boolean,
  edited: Availability,
  manualDays: Record<string, { providerIds: number[], availabilityIds: number[] }>,
  selectedDate: Date,
  setEdited: (a: Availability) => void,
}

const EditAvailabilityOccurs = ({ disabled, edited, manualDays, selectedDate, setEdited }: Props) => {
  const setRepeats = (value: string) => {
    const parts = value.split('-');
    const freq = parseInt(parts[0]) as Frequency;
    const interval = parseInt(parts[1]);

    if (freq === RRule.DAILY && edited.rrule.freq !== RRule.DAILY) {
      setEdited({ ...edited, rrule: {
        freq: RRule.DAILY,
        dtstart: edited.rrule.dtstart,
        until: edited.rrule.dtstart,
      }});
    } else {
      setEdited({ ...edited, rrule: {
        freq: RRule.WEEKLY,
        dtstart: edited.rrule.dtstart,
        interval,
        // rrule uses 0 = Mon, while JS uses 0 = Sun
        byweekday: edited.rrule.freq === RRule.WEEKLY ? edited.rrule.byweekday : [ALL_WEEKDAYS[(selectedDate.getDay() + 6) % 7]]
      }});
    }
  }

  let days: string[] = [];
  if (edited.type === "calendar_block") {
    days = Object.keys(manualDays).filter(day => manualDays[day].availabilityIds.includes(edited.id));
  } else {
    days = Object.keys(manualDays).filter(day => manualDays[day].providerIds.includes(edited.providerId));
  }

  const rule = new RRule(edited.rrule);
  const warningDays = days.filter(day => {
    const date = new Date(day);

    // If there's a match - the rrule would apply on the same day as a manually edited thing -
    // then we want to display this information in the dialogue.
    return rule.between(date, date, true).length;
  });

  return <>
    <Grid size={3}>
      <span>
        <span style={{ paddingRight: "0.5em" }}>Occurs</span>
        <Tooltip title={<>
          Because of manual edits in the command center, changes here will not override {edited.type === "calendar_block" ? defaultCalendarBlockTitles[edited.blockType].toLowerCase() : "shifts"} on
          <ul>{warningDays.map(d => <li key={d}>{d}</li>)}</ul>
        </>}>
          <Badge badgeContent={warningDays.length} color="warning" anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{ cursor: "help" }}>
            <span>&nbsp;</span>
          </Badge>
        </Tooltip>
      </span>
    </Grid>
    <Grid size={9}>
      <Select
        value={`${edited.rrule.freq}-${(edited.rrule as any).interval ?? 1}`}
        onChange={(e) => setRepeats(e.target.value)}
        disabled={disabled}
        sx={{ width: "100%" }}
      >
        <MenuItem value={`${RRule.DAILY}-1`}>{freqToString(RRule.DAILY, 1)}</MenuItem>
        <MenuItem value={`${RRule.WEEKLY}-1`}>{freqToString(RRule.WEEKLY, 1)}</MenuItem>
        <MenuItem value={`${RRule.WEEKLY}-2`}>{freqToString(RRule.WEEKLY, 2)}</MenuItem>
      </Select>
    </Grid>
  </>
}

export default EditAvailabilityOccurs;
